<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
               <p class="ms-2 fs-10 fw-semibold">{{copyright}}</p>
            </div>
        </div>
    </div>
</footer>